import React from "react"

 
 

class Spinner extends React.Component {
  constructor(props) {
    super(props)
    this.myRef = React.createRef()
    this.state = {
       
    }
   
  }
 

 

  render() {
    return (

<div className="spinner">Loading...</div>
     
    )
  }
}

 

export default Spinner